export class Shortcode {
  constructor(public code: string, public example: string) {
  }
}
